import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS } from "../ActionType/ActionType";
import {toast} from 'react-toastify'
import { auth } from "../../config/firebaseConfig";

const initState={
    isLoading: false,
    currentUser : auth.currentUser,
}

export const LoginReducer=(state=initState, action)=>{
    switch (action.type) {
        case LOGIN_REQUEST:
            return{...state, isLoading: true}
        case LOGIN_SUCCESS:
            toast.success("Connexion réussie")
            return{...state, isLoading : false, currentUser : action.currentUser}
        case LOGIN_FAILURE:
            toast.error("Connexion échouée")
            return {...state, isLoading: false,}
        default:
            return {...state, isLoading: false};
    }
}